import { Table, TableBody, TableCell, TableHeadCell, TableRow } from 'components/Table';
import {
  ProjectSection,
  ProjectSectionContent,
  ProjectSectionHeading,
  ProjectTextRow,
} from 'layouts/Project';
import styles from '../Stack.module.css';

/* Everything with a plug. Two desks: the one I game at and the one I work at. */

function Section({ heading, children }) {
  return (
    <ProjectSection padding="none" className={styles.section}>
      <ProjectSectionContent>
        <ProjectTextRow stretch width="m">
          <ProjectSectionHeading>{heading}</ProjectSectionHeading>
          <Table>
            <TableBody>{children}</TableBody>
          </Table>
        </ProjectTextRow>
      </ProjectSectionContent>
    </ProjectSection>
  );
}

function Item({ label, name, children }) {
  return (
    <TableRow>
      <TableHeadCell>{label}</TableHeadCell>
      <TableCell>
        {name}
        {children && (
          <>
            <br />
            <span className={styles.note}>{children}</span>
          </>
        )}
      </TableCell>
    </TableRow>
  );
}

export function HardwareContent() {
  return (
    <>
      <Section heading="Desktop">
        <Item label="CPU" name="Intel Core i9-13900K">
          I had to RMA the first one over the oxidation fault, and the
          replacement has been fine since. Update your BIOS.
        </Item>
        <Item label="GPU" name="Gigabyte GAMING OC GeForce RTX 4090">
          Stupidly overpowered. I&apos;ll never push it to its limit.
        </Item>
        <Item label="Memory" name="G.Skill Trident Z5 64GB DDR5-6400">
          The largest fast DDR5 kit my board would take at the time.
        </Item>
        <Item label="Motherboard" name="Asus ROG MAXIMUS Z690 HERO">
          Cheap as previous-gen, with a better memory controller than any Z790
          under $1,000. The 4090 blocks the second PCIe x16 slot.
        </Item>
        <Item label="Case" name="Corsair 1000D Airflow">
          Overkill, and I&apos;m not sure what it buys you. Enormous, heavy to
          move, and the airflow was never going to be the bottleneck.
        </Item>
      </Section>

      <Section heading="Desktop peripherals">
        <Item label="Primary monitor" name={'Asus VG279QM 27" 1080p IPS 280Hz'}>
          280Hz with G-Sync, but I&apos;d go 1440p next time.
        </Item>
        <Item label="Secondary monitor" name={'MSI MAG 275QF 27" QHD 180Hz'} />
        <Item label="Keyboard" name="SteelSeries Apex Pro TKL (Hall Effect)">
          Bought for the hall effect switches.
        </Item>
        <Item label="Mouse" name="Razer Viper V3 Pro">
          The one I keep coming back to, on shape, weight and sensor.
        </Item>
        <Item label="Headphones" name="Sony WH-1000XM6">
          Replaced my AirPods Max before a flight. They are a third of the
          weight, and the noise cancelling holds up. I&apos;m not as much of a fan of the
          fit as the AirPods Max.
        </Item>
        <Item label="Microphone" name="Blue Yeti Blackout Edition">
          Cheap, everywhere second-hand, and good. I own three.
        </Item>
      </Section>

      <Section heading="Desk">
        <Item label="Laptop" name={'MacBook Pro 14" M5 Pro (48GB)'}>
          Runs Kubernetes clusters locally without complaint. Brew and a real
          Unix underneath are most of why I stay on it.
        </Item>
        <Item label="Primary monitor" name={'Samsung 28" UR550 4K'}>
          A hand-me-down from a friend. The DPI is what makes it, because text
          in an IDE is a different thing at 4K.
        </Item>
        <Item label="Secondary monitor" name={'Dell S2417DG 27" 1440p 165Hz'}>
          Eight years old and still going. Small by current standards.
        </Item>
        <Item label="Keyboard" name="Logitech Ergo K860">
          A split layout to force myself to touch-type properly. The wrist
          position was the bonus.
        </Item>
        <Item label="Pointer" name="Apple Magic Trackpad">
          The gestures beat a mouse on macOS, especially across virtual
          desktops.
        </Item>
        <Item label="Desk" name="Mighty Ape Gorilla Electric Standing Desk">
          My WFH standing desk setup, pairs with the walking pad.
        </Item>
        <Item label="Chair" name="Ergo Choice K2 Executive">
          $200 and better than any gaming chair, all of which are a scam. Buy an
          office chair locally, from somewhere that lets you sit in it first.
        </Item>
        <Item label="Treadmill" name="DynaSpace L3 Under Desk Walking Pad">
          Under the desk for the WFH days.
        </Item>
        <Item label="Dock" name="HP Thunderbolt 4 100W G6 Dock">
          Macs are stingy about display output over one Thunderbolt port. Both
          monitors run through the dock, one direct and one via a USB-C to
          DisplayPort adaptor, so the laptop takes a single cable.
        </Item>
      </Section>
    </>
  );
}
